<template>
    <div class="score-by-subject-question">
        <div class="title">
            {{ $t('values.scoreByQuestion') }}
        </div>
        <b-form-select
            :options="subjectsOptions(values)"
            v-model="subjectOptionSelected"
            @change="triggerChart(values)"
        >
        </b-form-select>
        <line-chart
            :height="120"
            :chart-data="datacollection"
            :plugins="[
                {
                    beforeInit: function (chart, args, options) {
                        chart.legend.afterFit = function () {
                            this.height += 20
                        }
                    },
                },
            ]"
        ></line-chart>
    </div>
</template>

<script>
import LineChart from './LineChart.js'

export default {
    components: {
        LineChart,
    },
    props: {
        values: Array,
    },
    data() {
        return {
            subjectOptionSelected: null,
            datacollection: {
                labels: [],
                datasets: [],
            },
        }
    },
    methods: {
        subjectsOptions(values) {
            let options = []
            options.push({
                value: null,
                text: this.$t('values.selectASubject'),
                disabled: true,
            })
            values.forEach((item) => {
                options.push({ value: item.value.id, text: item.value.title })
            })

            return options
        },
        triggerChart(data) {
            console.log(data)
            data.forEach((item) => {
                if (item.value.id === this.subjectOptionSelected) {
                    let questions = []
                    let scores = []
                    let datasets = []

                    item.key_behaviors.forEach((key_behavior) => {
                        questions.push(key_behavior.key_behavior.title)

                        if (key_behavior.networks_results.self) {
                            scores.push(key_behavior.networks_results.self.rating_score)
                        }
                    })

                    if (scores.length) {
                        datasets.push({
                            data: scores,
                            label: this.$t('values.table.self'),
                            borderColor: '#468B7F',
                            fill: false,
                        })
                    }

                    scores = []

                    item.key_behaviors.forEach((key_behavior) => {
                        if (key_behavior.networks_results.leader) {
                            scores.push(key_behavior.networks_results.leader.rating_score)
                        }
                    })

                    if (scores.length) {
                        datasets.push({
                            data: scores,
                            label: this.$t('values.table.leader'),
                            borderColor: '#F7A310',
                            fill: false,
                        })
                    }

                    scores = []

                    item.key_behaviors.forEach((key_behavior) => {
                        if (key_behavior.networks_results.peer) {
                            scores.push(key_behavior.networks_results.peer.rating_score)
                        }
                    })

                    if (scores.length) {
                        datasets.push({
                            data: scores,
                            label: this.$t('values.table.peer'),
                            borderColor: '#8C7EDF',
                            fill: false,
                        })
                    }

                    scores = []

                    item.key_behaviors.forEach((key_behavior) => {
                        if (key_behavior.networks_results.team) {
                            scores.push(key_behavior.networks_results.team.rating_score)
                        }
                    })

                    if (scores.length) {
                        datasets.push({
                            data: scores,
                            label: this.$t('values.table.team'),
                            borderColor: '#BD4545',
                            fill: false,
                        })
                    }

                    scores = []

                    this.$set(this.datacollection, 'labels', questions)

                    this.$set(this.datacollection, 'datasets', datasets)
                }
            })
        },
    },
}
</script>

<style lang="sass">
.score-by-subject-question
	margin-top: 2rem
	margin-bottom: 2rem
	padding: 1rem
	border: 1px solid rgba(0, 0, 0, 0.1)
	box-sizing: border-box
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.24)
	border-radius: 5px
	.title
		font-size: 0.8rem
		color: #6E6E6E
		font-weight: 700
	.custom-select
		max-width: 37.5rem
		margin-top: .5rem
		margin-bottom: 1.25rem
</style>
